import "./Backdrop.css";

const Backdrop = () => {
  return (
    <div className="container">
      <div className="backdrop">
        <h3>Loading...</h3>
      </div>
    </div>
  );
};

export default Backdrop;
